import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import DriverExpenseAccount from './driver-expense-account.jsx';
//import DriversExpenseAccountsMonthlyCompanyDriversVATBreakdown from
import MonthlyVatReport from '../../finance/monthly-vat-report.jsx'
import DatePicker from 'react-datepicker';

export default class DriversExpenseAccounts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      drivers_expense_accounts: props.driversExpenseAccountsAll || [],
      isLoading: true,
      url: props.url || '',
      startDate:moment().toDate(),
    };

    if (this.state.isLoading === true) {
      this.getDriversExpenseAccounts();
    }
  }
  handleStartDateChange(date) {
      this.setState({startDate: date})
  }
  getDriversExpenseAccounts() {
    let url = this.state.url;
    return fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer '+window.api_token
        ,"Accept": 'application/json'
      },
    }).
    then((responseText) => {
      let response = responseText.json();
      response.then((driversExpenseAccountsJson) => {
        this.setState({
          drivers_expense_accounts: driversExpenseAccountsJson,
          isLoading: false,
        })
      });
    });
  }

  handleExpenseAccountMonthlyVATBreakdownButtonClicked(companyShortName) {
    $('#drivers-expense-accounts-monthly-company-drivers-vat-breakdown-modal').data('company-short-name', companyShortName);
    //$('#drivers-expense-accounts-monthly-company-drivers-vat-breakdown-modal span.modal-title-part-company-short-name').html(companyShortName);
    $('#drivers-expense-accounts-monthly-company-drivers-vat-breakdown-modal').modal('show');

    if (document.getElementById(
      'react-component-g4-logistics-portal-drivers-expense-accounts-monthly-company-drivers-vat-breakdown')) {
      ReactDOM.unmountComponentAtNode(
        document.getElementById(
          'react-component-g4-logistics-portal-drivers-expense-accounts-monthly-company-drivers-vat-breakdown')
      );
      ReactDOM.render(
        <MonthlyVatReport/>,
        document.getElementById(
          'react-component-g4-logistics-portal-drivers-expense-accounts-monthly-company-drivers-vat-breakdown')
      );
    }
  }
  handleDriverExpenseAccountButtonClicked(e){
    let selectedDate = moment(this.state.startDate).format("YYYY-MM-DD");
    let url = "/api/v1/portal/finance/driver-account-expense-report/"+selectedDate;
        return fetch(url,{
            method: "GET",
            mode: "cors",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
              "Authorization": 'Bearer ' + window.api_token
              , "Accept": 'application/json',
              'Content-Type': 'multipart/form-data'
            }
          }
        ).then(response => response.blob())
        .then(blob => {
            var url = window.URL.createObjectURL(blob);
            var a = document.createElement('a');
            a.href = url;
            a.download = "Driver Account Expense Report " + moment(this.state.startDate).format("YYYY-MM-DD HH:mm:ss")+".xlsx";
            document.body.appendChild(a); 
            a.click();    
            a.remove(); 
        }).catch(err=>{
           alert('sorry something went wrong.') ;
        });
  }

  render() {
    let Drivers = [];

    if (this.state.drivers_expense_accounts &&
        this.state.drivers_expense_accounts.length > 0) {
        this.state.drivers_expense_accounts.forEach(function(i) {
          if(i.driver.expense_account!=null)
          {
            Drivers.push(<DriverExpenseAccount
              key={'driver-expense-account-'+i.id} data={i} />);
          }
        });
    }

    return (
      <div>
        {
        this.state.isLoading ?
          (<div className="loading-box">
            <span className="add-loading-text">
              <i className="fa fa-spinner fa-pulse"></i>
            </span>
          </div>) :
          <div>
            <button
               className="btn btn-lg btn-default"
               onClick={() => {
                 this.handleExpenseAccountMonthlyVATBreakdownButtonClicked(
                   'acv')
               }}>
                <i className="far fa-calendar-alt"></i>&nbsp;
              Monthly VAT Breakdown for Drivers
            </button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

            <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={(e)=>this.handleStartDateChange(e)} selected={this.state.startDate}/>
            &nbsp;

            <button
               className="btn btn-lg btn-default"
               onClick={() => {
                 this.handleDriverExpenseAccountButtonClicked(
                   'acv')
               }}>
                <i className="far fa-calendar-alt"></i>&nbsp;
                Drivers expense account
            </button>
            {Drivers}
        </div>
      }
     </div>
    );
  }
}

if (document.getElementById('react-component-g4-logistics-portal-drivers-expense-accounts')) {
  ReactDOM.render(<DriversExpenseAccounts
      url = {"/api/v1/portal/drivers/expense-accounts"}
      message_if_none = 'Expense accounts not found or available for viewing.'
    />,
    document.getElementById('react-component-g4-logistics-portal-drivers-expense-accounts'));
}